module.exports = __webpack_public_path__ + "img/64ae94d.jpg";